import { t } from 'i18next';
import moment from 'moment';
import React from 'react';

class SpecialInstructionDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetails: false,
    };
  }

  toggleDetails = () => this.setState({ showDetails: !this.state.showDetails });

  render() {
    const { instruction } = this.props;

    const { showDetails } = this.state;

    const instructions = instruction.get('instructions', t('rma.naQuestion', 'N/A?'));
    const updateUser = instruction.get('updated_by', null);
    const updateUserDisplay = updateUser
      ? updateUser.get('first_name', '') + ' ' + updateUser.get('last_name', '')
      : t('rma.na', 'N/A');

    const updatedAt = moment(instruction.get('updated', null));
    const updatedAtTimeFrom = updatedAt.fromNow();
    const updatedAtFormatted = updatedAt.format('L, LTS');

    const createUser = instruction.get('created_by', null);
    const createUserDisplay = createUser
      ? createUser.get('first_name', '') + ' ' + createUser.get('last_name', '')
      : t('rma.na', 'N/A');

    const createdAt = moment(instruction.get('created', null));
    const createdAtTimeFrom = createdAt.fromNow();
    const createdAtFormatted = createdAt.format('L, LTS');

    const toggleButton = (
      <i
        className={showDetails ? 'fa fa-minus' : 'fa fa-plus'}
        style={{
          cursor: 'pointer',
          color: 'var(--text-secondary)',
          padding: '3px',
          marginRight: '4px',
        }}
        title={t('rma.moreDetails', 'More details')}
        onClick={this.toggleDetails}
      />
    );

    const fullCreatedDisplay = (
      <span>
        {createUserDisplay} - <span title={createdAtFormatted}>{createdAtTimeFrom}</span>
      </span>
    );
    const fullUpdatedDisplay = (
      <span>
        {updateUserDisplay} - <span title={updatedAtFormatted}>{updatedAtTimeFrom}</span>
      </span>
    );

    return (
      <div
        style={{
          border: '1px solid #666',
          borderRadius: '4px',
          flex: '0 0 100%',
          marginBottom: '8px',
        }}
      >
        <div style={{ fontSize: '14px', padding: '8px' }}>
          <div style={{ fontWeight: 'bold', fontSize: '13px' }}>
            <div style={{ display: 'flex' }}>
              <div style={{ display: 'flex' }}>
                <div>{updateUser !== null ? toggleButton : null}</div>
                {showDetails ? (
                  <div>
                    <div>
                      {t('rma.updatedLabel', 'Updated:')} {fullUpdatedDisplay}
                    </div>
                    <div>
                      {t('rma.createdLabel', 'Created:')} {fullCreatedDisplay}
                    </div>
                  </div>
                ) : (
                  <div> {updateUser !== null ? fullUpdatedDisplay : fullCreatedDisplay}</div>
                )}
              </div>
            </div>
          </div>
          <div style={{ padding: '4px 0' }}>{instructions}</div>
        </div>
      </div>
    );
  }
}
export default SpecialInstructionDisplay;
